import { Directive, EventEmitter, Inject, Input, Self } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { debounceTime } from 'rxjs/operators/debounceTime';
import { Subject } from 'rxjs/Subject';
/**
 * @hidden
 */
var FilterInputDirective = /** @class */ (function () {
    function FilterInputDirective(valueAccessors) {
        var _this = this;
        this.change = new EventEmitter();
        this.filterDelay = 500;
        this.changeRequests = new Subject();
        this.accessor = valueAccessors[0];
        this.changeRequestsSubscription = this.changeRequests
            .pipe(debounceTime(this.filterDelay))
            .subscribe(function (x) { return _this.change.emit(x); });
    }
    Object.defineProperty(FilterInputDirective.prototype, "value", {
        set: function (value) {
            this.accessor.writeValue(value);
        },
        enumerable: true,
        configurable: true
    });
    FilterInputDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.accessor.registerOnChange(function (x) {
            return _this.filterDelay > 0 ?
                _this.changeRequests.next(x) :
                _this.change.emit(x);
        });
    };
    FilterInputDirective.prototype.ngOnDestroy = function () {
        this.changeRequestsSubscription.unsubscribe();
    };
    FilterInputDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[kendoFilterInput]'
                },] },
    ];
    /** @nocollapse */
    FilterInputDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: Self }, { type: Inject, args: [NG_VALUE_ACCESSOR,] },] },
    ]; };
    FilterInputDirective.propDecorators = {
        'filterDelay': [{ type: Input },],
        'value': [{ type: Input },],
    };
    return FilterInputDirective;
}());
export { FilterInputDirective };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/filtering/filter-input.directive.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/filtering/filter-input.directive.js
// module chunks = vendor